/**
 * Studio SSO configuration (task_2500b PR 3).
 *
 * Hub's auth is migrating from local JWT to Studio-issued `.graymatterlab.ai`
 * cookie sessions. `VITE_AUTH_MODE` mirrors the backend `AUTH_PROVIDER` flag so
 * the frontend's behavior flips in lockstep: it stays `hub_jwt` (default,
 * zero behavior change) through PR 3 and flips to `studio_sso` in PR 4.
 */

export type AuthMode = "hub_jwt" | "studio_sso";

export const STUDIO_URL: string =
  import.meta.env.VITE_STUDIO_URL || "https://studio.graymatterlab.ai";

export const AUTH_MODE: AuthMode =
  import.meta.env.VITE_AUTH_MODE === "studio_sso" ? "studio_sso" : "hub_jwt";

export const isStudioSso = (): boolean => AUTH_MODE === "studio_sso";

/**
 * Studio login URL with a `return` param so Studio bounces the user back to
 * where they started. Encodes the full href (not just origin) so deep links
 * survive the round trip.
 */
export function studioLoginUrl(returnTo: string = window.location.href): string {
  // Studio's canonical login route is /signin (there is no /login — it
  // falls through Studio's catch-all to /chat). Confirmed with Studio (task_077).
  return `${STUDIO_URL}/signin?return=${encodeURIComponent(returnTo)}`;
}
